import * as tslib_1 from "tslib";
import React from 'react';
import RDP from 'react-datepicker';

var ReactDatepicker =
/** @class */
function (_super) {
  tslib_1.__extends(ReactDatepicker, _super);

  function ReactDatepicker(props) {
    var _this = _super.call(this, props) || this;

    _this.ownDeferFocusInput = function () {
      _this.cancelFocusInput();

      _this.inputFocusTimeout = setTimeout(_this.setFocus, 1);
    };

    _this.deferFocusInput = function () {};

    var calendar = null; // fix an incompatibility of react-datepicker and react-select
    // https://github.com/Hacker0x01/react-datepicker/issues/730

    Object.defineProperty(_this, 'calendar', {
      get: function get() {
        return calendar;
      },
      set: function set(v) {
        if (!calendar && v) {
          v.componentNode.addEventListener('click', _this.ownDeferFocusInput);
        }

        calendar = v;
      }
    });
    var _a = _this,
        handleTimeChange = _a.handleTimeChange,
        shouldCloseOnSelect = _a.props.shouldCloseOnSelect;

    _this.handleTimeChange = function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      if (shouldCloseOnSelect) {
        _this.setState({
          preventFocus: true
        }, function () {
          setTimeout(function () {
            return _this.setState({
              preventFocus: false
            });
          }, 50);
        });
      }

      handleTimeChange.apply(_this, args);
    }; // fix focus of time picker
    // https://github.com/Hacker0x01/react-datepicker/pull/1331


    var onInputClick = _this.onInputClick;

    _this.onInputClick = function (e) {
      var target = e.target;
      setTimeout(function () {
        var baseClass = 'react-datepicker__time-list';
        var field = target.closest('.nx-datefield');
        var list = field && field.querySelector("." + baseClass);
        var item = list && list.querySelector("." + baseClass + "-item--selected");

        if (item) {
          list.scrollTop = item.offsetTop - list.offsetHeight / 2 + item.offsetHeight / 2;
        }
      }, 0);
      onInputClick.apply(_this, e);
    };

    return _this;
  }

  return ReactDatepicker;
}(RDP); // fix when date does not change if you use input to modify time only
// https://github.com/Hacker0x01/react-datepicker/issues/1446


var withFixForTimePicker = function withFixForTimePicker(Component) {
  return (
    /** @class */
    function (_super) {
      tslib_1.__extends(class_1, _super);

      function class_1() {
        return _super !== null && _super.apply(this, arguments) || this;
      }

      class_1.prototype.render = function () {
        var _a = this.props,
            allowSameDay = _a.allowSameDay,
            showTimeSelect = _a.showTimeSelect;
        return React.createElement(Component, tslib_1.__assign({}, this.props, {
          allowSameDay: showTimeSelect || allowSameDay
        }));
      };

      return class_1;
    }(Component)
  );
};

export default withFixForTimePicker(ReactDatepicker);